import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Sidebar from './Sidebar'
import { getInitials } from '../data/mockData'
import { useAuth } from '../context/AuthContext'
import { useApp } from '../context/AppContext'

export default function AppLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false)
  const { user } = useAuth()
  const { eventId } = useParams()
  const { events } = useApp()
  const [eventColor, setEventColor] = useState('#6c63ff')

  useEffect(() => {
    if (eventId && events.length > 0) {
      const currentEvent = events.find(e => e.id === eventId)
      if (currentEvent) {
        setEventColor(currentEvent.color)
      }
    } else {
      setEventColor('#6c63ff')
    }
  }, [eventId, events])

  const getSecondaryTextColor = (color) => {
    return '#222222'
  }

  const getNavBackground = (color) => {
    if (color === '#E8C1D1') return '#AE527D'
    return color
  }

  const lightenColor = (color, amount = 0.15) => {
    const c = parseInt(color.slice(1), 16)
    const r = Math.min(255, Math.floor((c >> 16) + (255 - (c >> 16)) * amount))
    const g = Math.min(255, Math.floor(((c >> 8) & 0xff) + (255 - ((c >> 8) & 0xff)) * amount))
    const b = Math.min(255, Math.floor((c & 0xff) + (255 - (c & 0xff)) * amount))
    return '#' + (r << 16 | g << 8 | b).toString(16).padStart(6, '0')
  }

  const activeColor = eventColor
  const secondaryTextColor = getSecondaryTextColor(eventColor)
  const navBgColor = getNavBackground(eventColor)
  const buttonHoverColor = lightenColor(activeColor)

  return (
    <div className="app-layout" style={{ '--event-color': activeColor, '--secondary-text-color': secondaryTextColor, '--card-border-color': eventColor, '--card-bg-color': eventColor + '33', '--page-bg-color': navBgColor, '--button-hover-color': buttonHoverColor }}>
      {/* Desktop sidebar */}
      <div className="sidebar">
        <Sidebar />
      </div>

      {/* Mobile sidebar overlay */}
      <div className={`sb-overlay ${mobileOpen ? 'open' : ''}`}>
        <div className="sb-overlay-bg" onClick={() => setMobileOpen(false)} />
        <div className="sb-overlay-panel">
          <Sidebar onClose={() => setMobileOpen(false)} />
        </div>
      </div>

      {/* Main */}
      <div className="main-content">
        {/* Mobile topbar */}
        <div className="mobile-topbar">
          <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)}>
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
              <path d="M1 1h18M1 8h18M1 15h18" stroke="#1a1a2e" strokeWidth="1.6" strokeLinecap="round"/>
            </svg>
          </button>
          <div className="mobile-logo">Plan<span>ora</span></div>
          <Link to="/profile" className="mobile-avatar" title="Min profil">
            {getInitials(user?.displayName || 'Bruger')}
          </Link>
        </div>

        {children}
      </div>
    </div>
  )
}
